import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { HttpService } from '../shared/services/http.service';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';

@Component({
    selector: 'app-bulk-client',
    templateUrl: './bulk-client.component.html',
    styleUrls: ['./bulk-client.component.scss'],
    standalone: false
})
export class BulkClientComponent implements OnInit {

  @Output() close: EventEmitter<Boolean> = new EventEmitter<Boolean>();

  selectedFile: File = null;
  bulkForm: UntypedFormGroup
  base64String = null

  sendgridTemplateId = 0

  processing = false

  errors = null
  clientCount = null
  data = null

  sendgridTemplateIds = [
    { label: "Welcome to Hemisphere - Education", value: "d-bb5ae606ccd044478368818f0ec706f3" }
  ]


  onEmailChange( event ){
    if( event.target.value ){
      this.sendgridTemplateId = event.target.value
    }
  }

  onFileSelected(event) {
    this.selectedFile = <File>event.target.files[0];
    this.errors = null
    const reader = new FileReader();
    reader.onload = () => {
      this.base64String = reader.result.toString();
      // Remove the data URI scheme and encoding
      this.base64String = this.base64String.replace(/^data:.+;base64,/, "");
      // Here you would typically call a service to upload the base64 string
    };
    reader.readAsDataURL(this.selectedFile);
  }

  async onSubmit() {

    if( !this.selectedFile ){
      return
    }

    this.processing = true

    const result :any = await this.httpService.postAsync( 'hclient/bulk', {
      file: this.base64String,
      fileName: this.selectedFile.name
    })

    this.processing = false

    if( !result.success ){
      this.errors = result.errors

      this.bulkForm.reset({
        file: [null]
      })

    }else{
      this.errors = null
      this.clientCount = result.data.length
      this.data = result.data
    }

  }

  constructor(private fb: UntypedFormBuilder, private httpService: HttpService) { }

  ngOnInit() {
    this.createClientForm()
  }

  createClientForm(){
    this.bulkForm = this.fb.group({
      file: [null, Validators.required]
    })
  }

  onClose(){
    this.close.emit(false)
  }

  async onImport(){

    this.processing = true


    try{
      const resp : any = await this.httpService.postAsync( 'hclient/import', {
        data: this.data,
        sendgridTemplateId: this.sendgridTemplateId
      })

      this.processing = false

      if( !resp.success ){
        alert( resp.message )
      }else{
        this.close.emit(true)
      }
    }catch( e ){
      alert("Import failed.")
    }

  }




}
